import { FC } from 'react';
import * as React from 'react';

import { clsx } from 'clsx';
import styled from 'styled-components';

import { useUITheme } from '@crehana/web';

import DashboardContextProvider from './context/DashboardContextProvider';

const Wrapper = styled.div`
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  transition: ${({ theme }) => theme.transition('background-color')};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    overflow: hidden;
  }
`;

export interface DashboardRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  supportsDarkMode?: boolean;
}

const DashboardRoot: FC<React.PropsWithChildren<DashboardRootProps>> = ({
  className,
  supportsDarkMode,
  children,
  ...rest
}) => {
  const { isDark } = useUITheme();
  const dark = supportsDarkMode && isDark;

  return (
    <DashboardContextProvider isDark={dark}>
      <Wrapper
        className={clsx(
          'relative w-full min-h-screen sm:h-screen sm:flex',
          dark ? 'bg-base-dark text-white' : 'bg-gray-lighter text-base-main',
          className,
        )}
        {...rest}
      >
        {children}
      </Wrapper>
    </DashboardContextProvider>
  );
};

export default DashboardRoot;
